import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type RoundsListQueryParams = Parameters<typeof SSF.api.roundsList>[0];

export const keys = createQueryKeySet<RoundsListQueryParams>('rounds');

export function useRoundsListQuery(params?: RoundsListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.roundsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useRoundDetailsQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.roundsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
